import { SENTIMENT_SOURCE } from "../sentiment";

// Tunable knobs for the User Segments widget.
export const CONFIG = {
  // Sentiment view's polarity source — shared dashboard-wide (see ../sentiment).
  sentimentSource: SENTIMENT_SOURCE,

  // Attribute lens toggle — the per-segment breakdown. Signals default.
  attributes: [
    { value: "signals", display: "Signals" },
    { value: "sentiment", display: "Sentiment" },
  ],
  defaultAttribute: "signals",

  topSignals: 4, // signal chips shown per segment
  maxSegments: 15, // segment rows to render
};
